package com.iregained.site.components.sections.about.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px

val AboutOriginContainerStyle = CssStyle.base {
    Modifier.fillMaxWidth().backgroundColor(Colors.White)
}

val AboutOriginGridStyle = CssStyle.base {
    Modifier.fillMaxWidth().maxWidth(1200.px).gap(60.px).padding(leftRight = 24.px)
}

val AboutOriginContentColumnStyle = CssStyle.base {
    Modifier.fillMaxWidth().display(DisplayStyle.Flex).flexDirection(FlexDirection.Column)
        .justifyContent(com.varabyte.kobweb.compose.css.JustifyContent.Center)
}

val AboutOriginOverlineStyle = CssStyle.base {
    Modifier.color(colorMode.toSitePalette().brand.primary) // Your Brand Teal
        .fontSize(1.12.cssRem).fontWeight(FontWeight.Bold)
        .textTransform(com.varabyte.kobweb.compose.css.TextTransform.Uppercase).letterSpacing(2.px)
        .margin(bottom = 16.px)
}

val AboutOriginHeadlineStyle = CssStyle.base {
    Modifier.color(colorMode.toSitePalette().custom.darkText).fontSize(2.5.cssRem).fontWeight(FontWeight.Bold)
        .lineHeight(1.2).margin(bottom = 24.px)
}

val AboutOriginParagraphStyle = CssStyle.base {
    Modifier.color(colorMode.toSitePalette().brand.primary).whiteSpace(WhiteSpace.PreWrap).fontSize(1.125.cssRem)
        .lineHeight(1.7).fontWeight(FontWeight.Medium).margin(bottom = 24.px)
}

// Gives the hardware/lab photo a premium, physical feel
val AboutOriginImageWrapperStyle = CssStyle.base {
    Modifier.fillMaxWidth().borderRadius(16.px).overflow(com.varabyte.kobweb.compose.css.Overflow.Hidden).boxShadow(
        offsetX = 0.px, offsetY = 12.px, blurRadius = 40.px, color = Colors.Black.copy(alpha = 15)
    )
}

val AboutOriginImageStyle = CssStyle.base {
    Modifier.fillMaxWidth().aspectRatio(16, 9).objectFit(ObjectFit.Cover)
}